import { render, staticRenderFns } from "./LLpayMechantActity.vue?vue&type=template&id=1f55f48e&scoped=true&"
import script from "./LLpayMechantActity.vue?vue&type=script&lang=js&"
export * from "./LLpayMechantActity.vue?vue&type=script&lang=js&"
import style0 from "./LLpayMechantActity.vue?vue&type=style&index=0&id=1f55f48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55f48e",
  null
  
)

export default component.exports